<mat-form-field
  class="fill-field"
  floatLabel="always"
  tooltip-position="below"
  matTooltipShowDelay="500"
  subscriptSizing="dynamic"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  (click)="isOpen = !isOpen"
>
  <mat-label>{{ colorPicker }}</mat-label>
  <input
    type="text"
    matInput
    [readonly]="true"
    [style.background]="colorPicker"
  />
</mat-form-field>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayHasBackdrop]="true"
  (backdropClick)="isOpen = false"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
>
  <div class="picker">
    <color-chrome (onChange)="handleChange($event)" [color]="colorPicker" />
    <div class="buttons">
      <button matButton="filled" color="primary" (click)="handleClick($event)">
        {{ 'igo.common.confirmDialog.applyBtn' | translate }}
      </button>
    </div>
  </div>
</ng-template>
